export interface AddonTemplate {
  name: string;
  price: number;
  currency?: string;
  desc: string;
  features: string[];
}

export const COMMON_ADDON_SUGGESTIONS: AddonTemplate[] = [
  {
    name: 'Dedicated IP Address',
    price: 1499,
    currency: 'INR',
    desc: 'Isolated IP address for maximum deliverability',
    features: ['Isolated IP pool', 'Reputation protection', 'Zero neighbor noise'],
  },
  {
    name: 'Priority 24/7 Support',
    price: 3999,
    currency: 'INR',
    desc: 'Direct phone line and sub-15 minute SLA response time',
    features: ['Direct phone & Slack line', 'Sub-15 min SLA response', 'Dedicated senior engineer'],
  },
  {
    name: 'Custom Domain SSL',
    price: 799,
    currency: 'INR',
    desc: 'Custom branded checkout and member portal subdomain',
    features: ['Auto TLS/SSL provisioning', 'Custom subdomain routing', 'White-label header'],
  },
  {
    name: 'Audit Logs & Compliance',
    price: 2999,
    currency: 'INR',
    desc: 'Extended 365-day security logs and SOC2 export tools',
    features: ['365-day log retention', 'SOC2 / HIPAA export tools', 'Automated anomaly alerts'],
  },
];
